import currencySymbol from '../../../../lib/currencySymbol'

export default (props, traits) => {
  const { country } = props
  const { colors, radiuses, rhythm, scale } = traits

  return {
    root: {
      marginTop: rhythm(1)
    },
    modal: {
      container: {
        textAlign: 'center'
      }
    },
    link: {
      cursor: 'pointer',
      fontSize: scale(-0.5)
    },
    results: {
      root: {
        marginBottom: rhythm(0.75),
        textAlign: 'left'
      }
    },
    pagination: {
      marginBottom: rhythm(1)
    },
    error: {
      marginBottom: rhythm(0.75),
      padding: `${rhythm(0.5)} ${rhythm(0.75)}`,
      fontSize: scale(-0.75),
      fontWeight: 'bold',
      textAlign: 'center',
      backgroundColor: colors.danger,
      color: colors.light,
      borderRadius: rhythm(radiuses.small)
    },
    copy: {
      marginBottom: rhythm(1)
    },
    target: {
      root: {
        position: 'relative',
        '&:before': {
          content: `"${currencySymbol(country)}"`,
          position: 'absolute',
          top: rhythm(1.175),
          left: 0,
          width: rhythm(1.125),
          height: rhythm(1.666),
          paddingRight: rhythm(0.25),
          lineHeight: rhythm(1.666),
          textAlign: 'right',
          opacity: 0.5,
          whiteSpace: 'nowrap',
          pointerEvents: 'none'
        }
      },
      field: {
        paddingLeft: rhythm(1.125)
      }
    },
    story: {
      field: {
        padding: rhythm(0.5),
        lineHeight: 1.5
      }
    }
  }
}



// WEBPACK FOOTER //
// ./components/slices/Registration/TeamRegistration/styles.js